/**
 * Clean user agent string by removing app-specific identifiers
 * Keeps only standard browser information
 * @param {string} userAgent - Raw user agent string
 * @returns {string} - Cleaned user agent string
 */
export const cleanUserAgent = (userAgent) => {
  if (!userAgent) return '';
  
  // Split by space and filter out app-specific parts
  const parts = userAgent.split(' ');
  const cleanParts = [];
  
  for (const part of parts) {
    // Keep standard browser parts
    if (
      part.startsWith('Mozilla/') ||
      part.startsWith('(') ||
      part.includes(')') ||
      part.startsWith('AppleWebKit/') ||
      part.startsWith('(KHTML,') ||
      part.includes('like') ||
      part.includes('Gecko)') ||
      part.startsWith('Version/') ||
      part.startsWith('Chrome/') ||
      part.startsWith('Safari/') ||
      part.includes('Mobile')
    ) {
      cleanParts.push(part);
    }
    // Stop when we hit app-specific identifiers
    else if (
      part.includes('musical_ly') ||
      part.includes('FBAV') ||
      part.includes('FBAN') ||
      part.includes('Instagram') ||
      part.includes('WhatsApp') ||
      part.includes('Twitter') ||
      part.includes('TikTok') ||
      part.includes('ByteDance') ||
      part.includes('JsSdk') ||
      part.includes('NetType') ||
      part.includes('Channel') ||
      part.includes('AppName') ||
      part.includes('app_version') ||
      part.includes('ByteLocale') ||
      part.includes('Region/') ||
      part.includes('AppId') ||
      part.includes('Spark') ||
      part.includes('AppVersion') ||
      part.includes('PIA')
    ) {
      break;
    }
  }
  
  return cleanParts.join(' ').trim();
};

/**
 * Get browser name from user agent string
 * @param {string} userAgent - User agent string
 * @returns {string} - Browser name
 */
export const getBrowserName = (userAgent) => {
  if (!userAgent) return 'Unknown';
  
  if (userAgent.includes('musical_ly') || userAgent.includes('TikTok')) return 'TikTok';
  if (userAgent.includes('FBAV') || userAgent.includes('FBAN')) return 'Facebook';
  if (userAgent.includes('Instagram')) return 'Instagram';
  if (userAgent.includes('WhatsApp')) return 'WhatsApp';
  if (userAgent.includes('Twitter')) return 'Twitter';
  if (userAgent.includes('Chrome')) return 'Chrome';
  if (userAgent.includes('Safari')) return 'Safari';
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Edge')) return 'Edge';
  
  return 'Unknown';
};

/**
 * Check if user agent is from a social media app
 * @param {string} userAgent - User agent string
 * @returns {boolean} - True if from social media app
 */
export const isSocialMediaApp = (userAgent) => {
  if (!userAgent) return false;
  
  const socialMediaApps = [
    'musical_ly', 'TikTok', 'FBAV', 'FBAN', 'Instagram', 
    'WhatsApp', 'Twitter', 'ByteDance'
  ];
  
  return socialMediaApps.some(app => userAgent.includes(app));
};